module.exports = __webpack_public_path__ + "img/image173.451e3f71.png";